"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchAffiliationDocumentFactory = void 0;
const Factory = require("factory.ts");
exports.batchAffiliationDocumentFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    original_filename: 'fake_filename.csv',
    csv_file: 'thirty_two_digit_fake_csv_file_x.csv',
    status: 'completed',
    inserted_count: 1,
    errored_count: 0,
    duplicated_count: 0,
    skipped_count: 0,
    user_id: 1,
    user_name: "fake username",
    error_message: null
});
